export var setNoFocus = function setNoFocus(props, enabled) {
  if (enabled === void 0) {
    enabled = false;
  }

  return enabled ? {
    tabIndex: -1,
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      props == null ? void 0 : props.onMouseDown == null ? void 0 : props.onMouseDown(e);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
      }

      props == null ? void 0 : props.onKeyUp == null ? void 0 : props.onKeyUp(e);
    }
  } : {};
};